import { FileFormatMap } from '../file-upload';
export function resolveMediaType(fileType) {
  switch (true) {
    case new RegExp(FileFormatMap.Video).test(fileType):
      return 'Video';
    case new RegExp(FileFormatMap.Audio).test(fileType):
      return 'Audio';
    case new RegExp(FileFormatMap.Image).test(fileType):
      return 'Image';
    case new RegExp(fileType).test(FileFormatMap.Document):
      return 'Document';
  }
  return;
}
//# sourceMappingURL=resolve-media-type.js.map